import { useCallback, useRef } from "react"
import * as amplitude from "@amplitude/analytics-react-native"
import { useStageFunnel } from "../context/StageFunnelContext"

/**
 * Ce qui situe un événement du funnel Stage : l'identifiant du parcours, le
 * stage vendu, l'intention de la landing et la source du lien d'entrée. La
 * formule sert à toutes les vacances : c'est l'intention
 * (`stage_vacances_scolaires_toussaint`) qui dit de quelles vacances il s'agit.
 * Les propriétés passées par l'écran priment (il connaît parfois une valeur
 * plus fraîche que le contexte).
 */
export const stageEventProperties = (state, properties = {}) => ({
    funnel_state_id: state?.funnelStateId ?? null,
    template_slug: state?.templateSlug ?? null,
    lead_intent: state?.leadIntent ?? null,
    source: state?.entrySource ?? null,
    ...properties,
})

/** Émet un événement du funnel Stage, situé par {@link stageEventProperties}. */
export const useStageTrack = () => {
    const { state } = useStageFunnel()
    const latest = useRef(state)
    latest.current = state

    return useCallback((event, properties) => {
        amplitude.track(event, stageEventProperties(latest.current, properties))
    }, [])
}
